import React from 'react'
import { useTranslation } from "react-i18next";
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogContent, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';


function SendAlertDialog(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_MessageContent = props.messageContent !== null && props.messageContent !== undefined ? props.messageContent : null;
    const inputParam_MessageType = props.messageType !== null && props.messageType !== undefined ? props.messageType : null;
    const inputParam_IsDialogOpen = props.isDialogOpen !== null && props.isDialogOpen !== undefined ? props.isDialogOpen : null;
    const inputParam_SetterIsDialogOpen = props.setIsDialogOpen !== null && props.setIsDialogOpen !== undefined ? props.setIsDialogOpen : null;
    
    //Parametros de componente.
    
    //Funciones de componente.

    //Eventos de componente.
    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsDialogOpen && inputParam_SetterIsDialogOpen();
    };

    //Render de componente.
    return (
            <Dialog
                hidden={!inputParam_IsDialogOpen}
                onDismiss={onHideDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: t('data-lang-dlg-title-message'),
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } },
                }}
                >
                <DialogContent>
                    { inputParam_MessageContent }
                </DialogContent>
                <DialogFooter>
                    <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-close')} />
                </DialogFooter>
            </Dialog>
    );
}

export default SendAlertDialog;

